<template>
  <div class="bbp-num-select">
    <i class="bbp-icon-minus-button bbp-num-select__icon bbp-num-select__icon_minus"
       :class="{'bbp-num-select__icon_disabled': (this.value - this.step) < this.minVal}"
       @mousedown="startSetCount()"
       @mouseleave="stopSetCount()"
       @mouseup="stopSetCount()"
       @click="changeValue()"/>
    <p class="bbp-num-select-time">
      <span class="bbp-num-select-time__value">
        <ICountUp
          :delay="countUp.delay"
          :startVal="minVal"
          :endVal="value"
          :options="countUp.options"
        />
      </span>
      <span>min</span>
    </p>
    <i class="bbp-icon-plus-button bbp-num-select__icon bbp-num-select_icon_plus"
       :class="{'bbp-num-select__icon_disabled': (this.value + this.step) > this.maxVal}"
       @mousedown="startSetCount(true)"
       @mouseleave="stopSetCount()"
       @mouseup="stopSetCount()"
       @click="changeValue(true)"/>
  </div>
</template>

<script>
import {get} from 'lodash'
import ICountUp from 'vue-countup-v2'

export default {
  name: 'BBPNumberSelect',
  props: ['model', 'input'],
  components: {
    ICountUp
  },
  data () {
    return {
      value: 0,
      interval: false,
      countUp: {
        delay: 0,
        options: {
          duration: 1,
          separator: '',
          decimal: '',
          decimalPlaces: 0
        }
      }
    }
  },
  computed: {
    minVal () {
      return get(this.input, 'minmax.min', 0)
    },
    maxVal () {
      return get(this.input, 'minmax.max', Infinity)
    },
    step () {
      return get(this.input, 'minmax.step', 10)
    }
  },
  methods: {
    startSetCount (add) {
      if (this.interval) return
      this.interval = setInterval(() => this.changeValue(add), 150)
    },
    stopSetCount () {
      clearInterval(this.interval)
      this.interval = false
    },
    setDefaultValue () {
      const defaultValue = get(this.input, 'defaultValue', this.minVal)
      this.value = get(this.model, this.input.model, defaultValue)
    },
    changeValue (add) {
      if (add) {
        this.value = (this.value + this.step > this.maxVal) ? this.maxVal : this.value + this.step
      } else {
        this.value = (this.value - this.step < this.minVal) ? this.minVal : this.value - this.step
      }
    }
  },
  watch: {
    value () {
      this.$emit('input', this.value)
    }
  },
  beforeMount () {
    this.setDefaultValue()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-num-select {
    @include global-font;
    display: inline-grid;
    grid-template-columns: 20px auto 20px;
    grid-gap: 8px;
    justify-content: start;
    align-items: center;
    width: auto;
    transition: 0.3s;

    &__icon {
      font-size: 20px;
      color: $color-accent;
      transition: 0.3s;
      cursor: pointer;

      &_disabled {
        color: $color-silver;
        pointer-events: none;
      }

      &:before {
        margin: 0;
      }

      &:hover {
        color: $color-accent-hover;
      }

      &:active {
        color: $color-tory-blue
      }
    }

    &-time {
      min-width: 50px;
      text-align: center;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 17px;
      user-select: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPNumberSelect/BBPNumberSelect.vue